import React, { /* useEffect, */ useState } from 'react';
/* import FaqAlt from 'components/pages/faq/faq-alt/FaqAlt'; */
import { Card, Col, Row } from 'react-bootstrap';
import PaymentTotals from './PaymentTotals';
import PaymentData from './PaymentData';
import PayMethods from './PayMethods';
import usePayment from './usePayment';
import Charging from 'components/common/Charging';
import ModalEfectyQr from './ModalEfectyQr';

const Payments = () => {
 const { isLoaded, onError, onSubmitData, watch, register, setValue, handleSubmit, errors, show, navigat, dataPay } = usePayment({
  acceptanc: true,
  defaultValues: {
   acceptance_token: '',
   amount: 0,
   amount_in_cents: 0,
   currency: 'COP',
   customer_email: '',
   payment_method: {},
   redirect_url: null,
   reference: '',
   customer_data: { email: '', phone_number: '', full_name: '', 'legal-id': '', 'legal-id-type': 'DNI' }
  }
 });
 const [method, setMethod] = useState({});

 return (
  <>
   {isLoaded && <Charging />}
   <ModalEfectyQr show={show} navigat={navigat} dataPay={dataPay} />
   <PaymentData watch={watch} register={register} setValue={setValue} />
   <Row className="g-3">
    <Col lg={8} className="pe-lg-2 mb-3">
     <Card className="h-100">
      <Card.Header>
       <h5 className="mb-0">Métodos de pago</h5>
      </Card.Header>
      <Card.Body className="bg-light">
       <PayMethods method={method} setMethod={setMethod} watch={watch} register={register} setValue={setValue} errors={errors} />
      </Card.Body>
     </Card>
    </Col>
    <Col lg={4} className="pe-lg-2 mb-3">
     <Card className="h-100">
      <Card.Header>
       <h5 className="mb-0">Resumen</h5>
      </Card.Header>
      <Card.Body className="bg-light">
       <PaymentTotals
        method={method}
        setMethod={setMethod}
        watch={watch}
        register={register}
        setValue={setValue}
        errors={errors}
        onError={onError}
        onSubmitData={onSubmitData}
        handleSubmit={handleSubmit}
       />
      </Card.Body>
     </Card>
    </Col>
   </Row>
   {/* <FaqAlt /> */}
  </>
 );
};

Payments.propTypes = {};

export default Payments;
